import { memo, useCallback, useState } from "react";
import { Order } from "../../../../interfaces/domain/menu";
import { Quantity } from "../../inputs/Quantity";
import { formatPrice } from "../../../../utils/formatersPrecio";
import styles from "./CartItem.module.scss";
import { useNavigate } from "react-router-dom";
import { useUIStore } from "../../../../store";

interface CartItemProps {
  order: Order;
}

export const CartItem = memo(({ order }: CartItemProps) => {
  const navigate = useNavigate();
  const [isRemoving, setIsRemoving] = useState(false);

  const setSection = useUIStore((s) => s.setSection);

  const isCombo =
    Array.isArray(order.comboSelection) &&
    order.comboSelection.length > 0;

  const handleEdit = useCallback(() => {
    const currentParams = new URLSearchParams(window.location.search);

    const name = currentParams.get("name");
    const color = currentParams.get("color");

    const nextParams = new URLSearchParams();
    nextParams.set("cartItem", order.cartItemId);

    if (name) nextParams.set("name", name);
    if (color) nextParams.set("color", color);

    setSection("productModal");
    navigate(`?${nextParams.toString()}`);
  }, [navigate, order.cartItemId, setSection]);

  const handleRemoveAnimation = () => {
    setIsRemoving(true);

    setTimeout(() => {
      // remove lo maneja Quantity
    }, 250);
  };

  return (
    <div
      className={`
        ${styles.wrapper}
        ${isRemoving ? styles.removing : ""}
      `}
    >
      <div className={styles.container}>
        <div className={styles.containerPriceTitle}>
          <p className={styles.title}>{order.title}</p>

          {!!order.description && !isCombo && (
            <p className={styles.description}>{order.description}</p>
          )}

          {isCombo && (
            <div className={styles.comboDetails}>
              {order.comboSelection!.map((item) => (
                <p key={item.id} className={styles.comboItem}>
                  • {item.quantity}x {item.title}
                </p>
              ))}
            </div>
          )}

          {order.resolvedOptions && order.resolvedOptions.length > 0 && (
            <div className={styles.comboDetails}>
              {order.resolvedOptions.map((group, gi) => (
                <div key={gi}>
                  <p className={styles.optionGroupLabel}>{group.groupName}</p>
                  {group.items.map((item, ii) => (
                    <p key={ii} className={styles.comboItem}>
                      • {item.qty > 1 ? `${item.qty}x ` : ""}
                      {item.name}
                      {item.price > 0 && ` +${formatPrice(item.price * item.qty)}`}
                    </p>
                  ))}
                </div>
              ))}
            </div>
          )}

          <p className={styles.priceTotal}>
            {formatPrice(order.price * order.quantity)}
          </p>

          <button
            type="button"
            className={styles.editButton}
            onClick={handleEdit}
          >
            Modificar
          </button>
        </div>
      </div>

      <div className={styles.containerQuantity}>
        <Quantity
          idItem={order.cartItemId}
          title={order.title}
          price={order.price}
          photo={order.image_url}
          onRemove={handleRemoveAnimation}
        />
      </div>
    </div>
  );
});